import { Field } from 'formik'
import {
  FC,
  Fragment,
  ChangeEvent,
  KeyboardEvent,
  useRef,
  useState,
  useEffect,
} from 'react'
import {
  StyleDidReceivedText,
  StyleOtpInput,
  StyleOtpWrapper,
  StyleResendText,
  StyleResendWrapper,
} from './style'
import ErrorMessage from '../ErrorMessage'
interface OtpInputProps {
  length?: number
  name: string
  onChange?: (value: string) => void
  onResend?: () => Promise<void>
}
const OtpInput: FC<OtpInputProps> = ({
  name,
  length = 6,
  onChange,
  onResend,
}) => {
  const inputRefs = useRef<(HTMLInputElement | null)[]>([])
  const [otp, setOtp] = useState<string[]>(new Array(length).fill(''))
  const [timeLeft, setTimeLeft] = useState(120)

  const handleChange = ({ value, index, form }: any) => {
    // Only take the last character if multiple digits are pasted/entered
    const sanitizedValue = value.slice(-1)

    const newOtp = [...otp]
    newOtp[index] = sanitizedValue
    const updateOtp = newOtp.join('')
    setOtp(newOtp)

    if (sanitizedValue && index < length - 1) {
      inputRefs.current[index + 1]?.focus()
    }
    form.setFieldValue(name, updateOtp)
    onChange && onChange(updateOtp)
  }

  const handleKeyDown = ({ key, index, form }: any) => {
    if (key === 'Backspace') {
      const newOtp = [...otp]
      if (!newOtp[index] && index > 0) {
        inputRefs.current[index - 1]?.focus()
      }
      newOtp[index] = ''
      const updateOtp = newOtp.join('')
      setOtp(newOtp)
      form.setFieldValue(name, updateOtp)
      onChange && onChange(updateOtp)
    }
  }
  const restartTimer = () => {
    onResend && onResend()

    setTimeLeft(120)
  }

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60)
    const secs = seconds % 60
    return `${minutes}:${secs.toString().padStart(2, '0')}`
  }
  useEffect(() => {
    if (timeLeft <= 0) {
      return
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1)
    }, 1000)

    return () => clearInterval(timer) // Cleanup on unmount
  }, [timeLeft])

  return (
    <Field name={name}>
      {({ form, meta }) => {
        const hasError = meta.touched && meta.error
        return (
          <>
            <StyleOtpWrapper>
              {otp?.map((value, index) => {
                return (
                  <Fragment key={index}>
                    <StyleOtpInput
                      type="number"
                      maxLength={1}
                      value={value}
                      ref={(el) => (inputRefs.current[index] = el)}
                      onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        handleChange({ value: e.target.value, index, form })
                      }
                      onKeyDown={(e: KeyboardEvent<HTMLInputElement>) =>
                        handleKeyDown({ key: e.key, index, form })
                      }
                    />
                  </Fragment>
                )
              })}
            </StyleOtpWrapper>
            <StyleResendWrapper>
              <StyleDidReceivedText>
                Didn&apos;t Receive OTP.
              </StyleDidReceivedText>
              {timeLeft > 0 ? (
                <>
                  <StyleResendText type="button" disabled>
                    Resend it in
                  </StyleResendText>
                  <StyleDidReceivedText>
                    {formatTime(timeLeft)}
                  </StyleDidReceivedText>
                </>
              ) : (
                <StyleResendText type="button" onClick={restartTimer}>
                  Resend now
                </StyleResendText>
              )}
            </StyleResendWrapper>

            {!!hasError && <ErrorMessage message={meta.error} />}
          </>
        )
      }}
    </Field>
  )
}

export default OtpInput
